import ApiClient from 'remote/api-client';

const get = (tenantId: string) =>
  ApiClient.get(`/feature-toggles?NamespaceId=${encodeURIComponent(tenantId)}`).promise();

export default { get };
